import React,{useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {useCookies} from 'react-cookie'
import { authURL, currUrl, pythonURL } from "./variables";

import Select from 'react-select';
import makeAnimated from 'react-select/animated';
const animatedComponents = makeAnimated();

export const ForecastModal = ({isForecastModal, setIsForecastModal, setAlertMsg}) =>
{
    const { clientDictShow } = useSelector((state) => state.client);
    const [cookies, setCookie, ] = useCookies(['redirection',"jwt"]);
    const [isLoading, setIsLoading] = useState("");
    const [data, setData] = useState({});
    const [payorFilter, setPayorFilter] = useState();
    const generateForecastReports = async () =>
    {
          setIsLoading('is-loading')
          await fetch (pythonURL+"/GenerateForecastReports",
          {
              method: 'post',
              headers: {"authorization" : cookies.jwt},
              body: new URLSearchParams({
                  "Name" : clientDictShow["Name"],
                  "catalogStatus" : JSON.stringify(clientDictShow["catalogStatus"]),
                  'PayorFilter': JSON.stringify(payorFilter),
              })
          })
          .then(async (data) => 
          {
              if(data.status === 403)
                  throw new Error('Whoops!');
              else if (data.status === 401)
              {
                  setCookie("redirection",currUrl,{"domain" : currUrl.includes("bitsonic") ? ".bitsonic.ai" : "localhost"});
                  window.location.href = authURL; 
              }
              if(data.status === 400)
                  alert(data['result']);
              else 
              {
                  data = await data.json();
                  alert(data['result'])
              }
              setIsLoading("");
          })
          .catch(error => {
              console.error('Error:', error);
              setAlertMsg(true);
              console.log("error " + error);
          });
          
    }
    const getPayors = async () =>
    {
        await fetch (pythonURL+"/GetPayors",
        {
            method: 'post',
            headers: {"authorization" : cookies.jwt},
            body: new URLSearchParams({
                "catalogs" : JSON.stringify(clientDictShow["catalogStatus"]),
            })
        })
        .then(async (data) => 
        {
            if(data.status === 403)
                throw new Error('Whoops!');
            else if (data.status === 401)
            {
                setCookie("redirection",currUrl,{"domain" : currUrl.includes("bitsonic") ? ".bitsonic.ai" : "localhost"});
                window.location.href = authURL; 
            }
            if(data.status === 400)
                alert(data['result']);
            else 
            {
                data = await data.json();
                setData(data['result'])
                setPayorFilter(Object.fromEntries(Object.entries(data['result']).map(([key, arr]) => [key, arr.map(item => item.value)])))
            }
            setIsLoading("");
        })
        .catch(error => {
            console.error('Error:', error);
            setAlertMsg(true);
            console.log("error " + error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {getPayors()}, [isForecastModal])
    return (<div className={"modal " + isForecastModal} style={{'height': '100%'}}>
                <div className="modal-background"></div>
                <div className="modal-card" style={{'height': '85%'}}>
                    <header className="modal-card-head">
                        <p className="modal-card-title">Forecast Modal</p>
                        <button className="delete" aria-label="close" onClick={() => setIsForecastModal("")}/>
                    </header>
                    <section className="modal-card-body" style={{'height': '100%', "overflowY" : "scroll"}}>
                        <center>
                            <h1 className="title m-2 p-0">Payors</h1>
                            {Object.entries(data)?.map(([catalog, options], idx) => (
                                <React.Fragment key={idx}>
                                    { clientDictShow["catalogStatus"][catalog] == 'owned' ?
                                        <div className="mb-6">
                                            <p className="title is-6 mb-2 p-0">{catalog}</p>
                                            <Select
                                                closeMenuOnSelect={false}
                                                components={animatedComponents} defaultValue={options} isMulti
                                                onChange={(e) => setPayorFilter({...payorFilter, [catalog]: e.map((val) => val.value)})} options={options}
                                            />
                                        </div>
                                        :<></>
                                    }
                                </React.Fragment>
                            ))}
                        </center>
                    </section>
                    <footer className="modal-card-foot buttons is-centered">
                        <div>
                            <button className="button" onClick={() => setIsForecastModal("")}>Cancel</button>
                            <button className={"button is-success " + isLoading} disabled={Object.entries(data).length <= 0} onClick={() => generateForecastReports()}>Run</button>
                        </div>
                    </footer>
                </div>
            </div>);
}